import { createWiseConnection } from '../components/API';

export async function openWiseConnectPage(windowRef?: WindowProxy | null) {
  const { agreementUrl } = await createWiseConnection();
  if (windowRef) {
    windowRef.location = agreementUrl;
  } else {
    window.open(agreementUrl);
  }
  localStorage.setItem(RedirectToConnectAccountsKey, window.location.pathname);
}

export const RedirectToConnectAccountsKey = 'redirectToConnectAccounts';
